export const flattenPosition = (xy) => xy.reduce((a, _, i) => {
    for (let j = 0; j < 4; j++) {
        a[Math.floor(i / 2) * 8 + (i % 2) + j * 2] = xy[i];
    }
    return a;
}, new Float32Array(xy.length * 4));
export const flattenNextPosition = (xy) => {
    const arrayWithNeighbors = new Float32Array(xy.length * 4);
    for (let j = 0; j < 4; j++) {
        arrayWithNeighbors[j * 2] = xy[2];
        arrayWithNeighbors[j * 2 + 1] = xy[3];
    }
    for (let i = 1; i < xy.length / 2; i++) {
        for (let j = 0; j < 2; j++) {
            arrayWithNeighbors[i * 8 + j * 2] = xy[i * 2 - 2];
            arrayWithNeighbors[i * 8 + j * 2 + 1] = xy[i * 2 - 1];
        }
        for (let j = 2; j < 4; j++) {
            arrayWithNeighbors[i * 8 + j * 2] = xy[i * 2 + 2];
            arrayWithNeighbors[i * 8 + j * 2 + 1] = xy[i * 2 + 3];
        }
    }
    for (let j = 0; j < 4; j++) {
        arrayWithNeighbors[xy.length * 4 + j * 2] = xy[xy.length - 2];
        arrayWithNeighbors[xy.length * 4 + j * 2 + 1] = xy[xy.length - 1];
    }
    return arrayWithNeighbors;
};
export const flattenDirections = (xy) => {
    const acc = new Float32Array((xy.length / 2) * 4);
    for (let index = 0; index < xy.length / 2; index++) {
        acc[index * 4] = 1;
        acc[index * 4 + 1] = -1;
        acc[index * 4 + 2] = -1;
        acc[index * 4 + 3] = 1;
    }
    return acc;
};
export const accXDistanceSoFar = (xy) => {
    const acc = new Float32Array((xy.length / 2) * 4);
    for (let index = 0; index < xy.length / 2; index++) {
        const prevDistance = index > 0 ? acc[index * 4 - 1] : 0;
        const x1 = xy[index * 2];
        const x0 = index > 0 ? xy[(index - 1) * 2] : x1;
        const distanceToPrevPoint = Math.abs(x0 - x1);
        const accDist = Number(distanceToPrevPoint + prevDistance);
        acc[index * 4] = accDist;
        acc[index * 4 + 1] = accDist;
        acc[index * 4 + 2] = accDist;
        acc[index * 4 + 3] = accDist;
    }
    return acc;
};
export const accYDistanceSoFar = (xy) => {
    const acc = new Float32Array((xy.length / 2) * 4);
    for (let index = 0; index < xy.length / 2; index++) {
        const prevDistance = index > 0 ? acc[index * 4 - 1] : 0;
        const y1 = xy[index * 2 + 1];
        const y0 = index > 0 ? xy[(index - 1) * 2 + 1] : y1;
        const distanceToPrevPoint = Math.abs(y0 - y1);
        const accDist = Number(distanceToPrevPoint + prevDistance);
        acc[index * 4] = accDist;
        acc[index * 4 + 1] = accDist;
        acc[index * 4 + 2] = accDist;
        acc[index * 4 + 3] = accDist;
    }
    return acc;
};
//# sourceMappingURL=utils.js.map